<template>
  <div>
    <h1>QR Code Unmatched</h1>
    <hr>
    <!-- FILTER START -->
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter Option</h4>
      </template>
      <div class="row outerBox filterBox">
          <div class="col row">
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                <label for="search_by">Search By</label>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ filterOptChosen.text }}&nbsp;<i class="fas fa-caret-down"></i></button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" v-for="opt in filterOpt" @click="filterOptChosen = opt">{{ opt.text }}</a>
                    </div>
                  </div>
                  <input v-model="keyword" type="text" class="form-control" aria-label="Text input with dropdown button">
                </div>
              </div>
              <div class="col-xs-6 col-sm-6 col-md-4 col-lg-4">
                <label>Karesidenan</label>
                <MultiSelect
                  :options="filterOption.karesidenan"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  label="name"
                  track-by="code"
                  :multiple="true"
                  v-model="selected.karesidenan"
                  placeholder="All Karesidenan"
                ></MultiSelect>
              </div>
              <div class="col-12 row">
                <div class="col-md-4 mt-2">
                  <button class="btn btn-primary w-100" type="button" @click="vue_universal_table.update++">
                    <span class="fa fa-filter"></span>&nbsp;&nbsp;Search
                  </button>
                </div>
                <div class="col-md-4 mt-2">
                  <button class="btn btn-success w-100" type="button" @click="showExcelModal = true">
                    <span class="fa fa-file-excel"></span>&nbsp;&nbsp;Export To Excel
                  </button>
                </div>
              </div>
          </div>
      </div>
    </panel>
    <!-- FILTER END -->

    <vue-universal-table
      :api_url="'/api/reports/qr-code-replacement'"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      :infinite_scroll="true"
    ></vue-universal-table>

    <transition name="modal" v-if="showExcelModal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="showExcelModal = false">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-3 col-lg-3"></div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div class="modal-container" @click.stop>

                <div class="modal-header" style="justify-content: flex-end;">
                  <button type="button" class="close" @click="showExcelModal = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                
                <div class="modal-body">
                  <h4>Please Select The Time Range To Generate the Excel Report</h4>

                  <p class="mt-2 mb-2" style="color:red">{{error}}</p>

                  <flat-pickr v-model="range" :config="rangeConfig" :placeholder="!isIEMode ? 'Select Date' : null"/>

                  <div class="row mt-4">
                    <div class="col-md-3 col-12">
                      <button type="button" @click="downloadExcel()" class="btn btn-success w-100">Download Excel</button>
                    </div>
                    <div class="col-md-3 col-12">
                      <button type="button" @click="showExcelModal = false" class="btn btn-danger w-100">Cancel</button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import MultiSelect from 'vue-multiselect'
  import flatPickr from 'vue-flatpickr-component'

  export default {
    data () {
      return {
        data : null,
        filterOption : {
          karesidenan : []
        },
        selected : {
          karesidenan : []
        },
        filterOpt: [
          {
            text: 'QR Code',
            value: 'qrcode'
          }, {
            text: 'Engine Number',
            value: 'engine_no'
          // }, {
          //   text: 'Serial Number',
          //   value: 'serial'
          }
        ],
        filterOptChosen : {
          text: 'QR Code',
          value: 'qrcode'
        },
        keyword: '',
        filter: {
          karesidenan : []
        },
        vue_universal_table : {
          fields : [
            {
              title : 'Old QR Code',
              variable : 'old_qr'
            },
            {
              title : 'New QR Code',
              variable : 'new_qr'
            },
            {
              title : 'Engine No',
              variable : 'engine_no'
            },
            {
              title : 'Frame No',
              variable : 'frame_no'
            },
            // {
            //   title : 'Reason',
            //   variable : 'reason'
            // },
            {
              title : 'Location',
              variable : 'loc_code'
            },
            {
              title : 'Replaced Date',
              variable : 'active_date'
            }
          ],
          update : 0,
        },
        range: '',
        showExcelModal: false,
        error: '',
        rangeConfig: {
          mode: 'range',
          altInput: true,
          animate: !this.isRTL()
        },
      }
    },
    components : {
      MultiSelect,
      flatPickr,
    },
    mounted () {
      this.getKaresidenan();
    },
    watch : {
      filterOptChosen : {
        handler(){
          for(var i = 0; i < this.filterOpt.length; i++){
            delete this.filter[this.filterOpt[i].value]
          }
          this.keyword = ''
        },
        deep : true,
      },
      keyword : {
        handler(){
          this.filter[this.filterOptChosen.value] = this.keyword
        }
      },
      'selected.karesidenan' : {
        handler(){
          this.filter.karesidenan.length = 0;
          for(var i = 0; i < this.selected.karesidenan.length; i++){
            this.filter.karesidenan.push(this.selected.karesidenan[i].code)
          }
        },
        deep : true,
      }
    },
    methods : {
      getKaresidenan(){
        this.filterOption.karesidenan = this.$store.getters.getKaresidenan
      },
      async downloadExcel (filter) {
        if (this.range == '') {
          this.error = "Please Select Time Range To Download The Excel"
          return;
        }
        let url = '/api/reports/qr-code-replacement/download-excel?' + await this.initialiseFilter()

        this.$http.get(url , {responseType : 'blob'})
        .then((resp)=>{
          const blob = new Blob([resp.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "QR Code Replacement Data (" + this.range + ")";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      initialiseFilter(){
        if(!(typeof this.filter === 'object' && this.filter !== null)){
          this.filterUrl = '';
          return;
        }
        var keys = Object.keys(this.filter);
        let stringUrl = '';
        var queryParams = this.filter;

        for(var i = 0 ; i < keys.length; i++){
          if(!queryParams[keys[i]])
            continue;

          if(queryParams[keys[i]] == '' || queryParams[keys[i]].length == 0)
            continue 

          if((keys[i] == 'user_type') && queryParams[keys[i]] == 'All')
            continue;
          
          // if(keys[i] == 'start_hour' || keys[i] == 'end_hour')
          //   queryParams[keys[i]] += ":00";

          stringUrl += `&${keys[i]}=${queryParams[keys[i]]}`;
          
        }
        
        if(this.range != ''){
          let splitDateRange = this.range.split(' to ');
          stringUrl = `${stringUrl}&start=${splitDateRange[0]}`
          stringUrl = `${stringUrl}&end=${splitDateRange[1]}`
        }

        return stringUrl;
      },
      // generateData () {
      //   var data = []
        
      //   for(var i = 0; i < 100; i++) {
      //     data.push({
      //       old_qr_code : this.randomInt(0,100000000000),
      //       new_qr_code : this.randomInt(0,100000000000),
      //       engine_number : this.randomInt(0,100000000000),
      //       frame_number : this.randomInt(0,100000000000),
      //       location : (this.randomInt(0,10)%2 ? 'H376' : 'H101')
      //     })
      //   }

      //   this.data = data;
      // }
    }
  }
</script>

<style scoped>
  .modal-mask {
      position: fixed;
      z-index: 1020;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
  }

  .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
  }

  .modal-container {
      width: 100%;
      margin: 0px auto;
      padding: 20px 30px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
      transition: all .3s ease;
      font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
      margin-top: 0;
      color: #42b983;
  }

  .modal-body {
      margin: 20px 0;
  }

  .modal-default-button {
      float: right;
  }

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
      opacity: 0;
  }

  .modal-leave-active {
      opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
  }

  /* MODAL STARTS */
  .modal-body{
      margin:0
  }

  .modal-body .moduleLine{
      margin-bottom: 0vh;
  }

  .modal-body .moduleLine a{
      text-decoration: none;
  }

  .modal-body .moduleLine .moduleBox:hover{
      background-color: #E0E0E0;
      transition: background-color 0.7s ease;
      color: #212121;
      transition: color 0.7s ease;
  }

  .modal-body .moduleLine .moduleBox{
      border:1px solid #BDBDBD;
      border-radius: 20px;
      padding: 20px 0;
      color:black;
      margin-bottom: 3vh;
  }

  .modal-body .moduleLine .moduleBox i{
      font-size:5vh;
  }

  h3.modalHeadline{
      margin:0 0 20px 0;
      font-weight: bold;
      text-align : center;
  }
  /* MODAL ENDS */
</style>
